import store from '@/store';
import { evaluate } from '@/acl';

export function useACL() {
    const can = (action, resource, attrs = {}) => {
        const policies = store.state.acl?.policies || [];
        return evaluate(policies, { action, resource, attrs });
    };
    return { can };
}
